import { createReducer } from '@reduxjs/toolkit';

import { DOCUMENT_SETUP_CLEAR_ALL_STATE } from '@app/store/actionTypes';
import { documentSetupSetupWithDraft } from '@app/store/documentSetup/actions';

import RequestMethod from '../RequestMethod';

const reducer = createReducer<RequestMethod | null>(null, (builder) =>
  builder
    .addCase(documentSetupSetupWithDraft, (state, action) => {
      const { entryPoint } = action.payload;

      if (entryPoint?.startsWith('drafts:')) {
        const draftId = entryPoint.split(':')[1];
        return { path: `/drafts/${draftId}` } as RequestMethod;
      }

      return null;
    })
    .addCase(DOCUMENT_SETUP_CLEAR_ALL_STATE, () => {
      return null;
    })
);

export default reducer;
